var MobileNavigation = /** @class */ (function () {
    function MobileNavigation() {
        this.body = document.body;
        this.header = document.querySelector('[data-header]');
        this.mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
        this.mobileMenu = document.querySelector('[data-mobile-menu]');
        this.submenuItem = document.querySelector('.submenu-toggle');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.addEventListeners();
    }
    MobileNavigation.prototype.addEventListeners = function () {
        var _this = this;
        this.mobileMenuToggle.addEventListener('click', function () { return _this.toggleNavigation(); });
    };
    MobileNavigation.prototype.toggleNavigation = function () {
        if (this.mobileMenuToggle.classList.contains('active')) {
            this.body.classList.remove('no-scroll');
            this.header.classList.remove('active');
            this.pageOverlay.classList.remove('visible');
            this.mobileMenuToggle.classList.remove('active');
            this.mobileMenu.classList.remove('open');
        }
        else {
            this.body.classList.add('no-scroll');
            this.header.classList.add('active');
            this.pageOverlay.classList.add('visible');
            this.mobileMenuToggle.classList.add('active');
            this.mobileMenu.classList.add('open');
        }
    };
    return MobileNavigation;
}());
export default MobileNavigation;
